module.exports = __webpack_public_path__ + "img/user.b12f1eec.svg";